import styled from 'styled-components';

const StyledCountrySelectorWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: auto;
  height: 100%;
  width: 60px;
`;

export default StyledCountrySelectorWrapper;
